// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"fce5a74d","186":"c9b8ad81","272":"fe770188","372":"62b81c97","377":"0441dd41","738":"43eb63b2","841":"b6af65bc","851":"969b5654","856":"24241574"}[chunkId] + ".chunk.js";
};